import axios from 'axios'
import { useCookies } from 'vue3-cookies'
import qs from 'qs'
// import mocktranslations from '@/config/transalations-mock.json'
import {
  OAUTH_BASE_URL,
  GATEWAY_BASE_URL,
  APPS_DASHBOARDS_URL,
  CUSTOMER_SETTINGS_URL,
  ROOT_SITE,
  FARMACLOUD_BASE_URL,
  FARMACLOUD_CLIENT_ID
} from './config'

export async function setLoginParams (params) {
  const { data } = await axios.get(`${OAUTH_BASE_URL}/authorize`, { params, withCredentials: true })
  this.authType = data.is_store ? 'store' : 'customer'
  // data.translations.es_es.media = data.translations.ca_es.media = mocktranslations
  if (data.is_store) {
    this.farmacloudLogin = `${FARMACLOUD_BASE_URL}/sso/${FARMACLOUD_CLIENT_ID}?login=farmacloud`
    this.rootSite = ROOT_SITE
    this.loginMethods = ['email']
  } else {
    this.signup = 'customer-signup'
  }
  return data
}

export async function loadSession (sessionId) {
  const { data } = await axios.get(`${OAUTH_BASE_URL}/session/${sessionId}`, { withCredentials: true })
  this.authType = data.is_store ? 'store' : 'customer'
  // data.translations.es_es.media = data.translations.ca_es.media = mocktranslations
  if (data.is_store) {
    this.farmacloudLogin = `${FARMACLOUD_BASE_URL}/sso/${FARMACLOUD_CLIENT_ID}?login=farmacloud`
    this.rootSite = ROOT_SITE
    this.loginMethods = ['email']
  } else {
    this.signup = 'customer-signup'
  }
  return data
}

export async function getToken () {
  const { data } = await axios.get(`${GATEWAY_BASE_URL}auth/user/v1/token`, { withCredentials: true })
  return data.token
}

export async function checkToken () {
  if (this.loginParams.without_farmacloud === '1') return
  // Check token
  const token = await getToken()
  if (token) {
    this.redirecting = true
    window.location = this.authType === 'store'
      ? APPS_DASHBOARDS_URL
      : CUSTOMER_SETTINGS_URL
    throw new Error('redirecting')
  }
  // Check farmacloud login
  if (this.authType !== 'store') return
  const { cookies } = useCookies()
  const cookieRedirectFcloud = cookies.get('redirect_fcloud') !== '1'
  if (cookieRedirectFcloud && this.loginParams.sso !== '0') {
    this.redirecting = true
    cookies.set('redirect_fcloud', '1')
    window.location = `${FARMACLOUD_BASE_URL}/sso/${FARMACLOUD_CLIENT_ID}?login=${encodeURIComponent(window.location.href)}`
    throw new Error('redirecting')
  } else {
    cookies.set('redirect_fcloud', '0')
  }
}

export async function setFavoriteStore ({ sessionId, storeId }) {
  const params = qs.stringify({ session_uuid: sessionId, favourite_store: storeId })
  const url = `${GATEWAY_BASE_URL}loyalty/brand/customer/card/favourite_store?${params}`
  return axios.put(url, {}, { withCredentials: false })
}

export async function sendAutologin (email) {
  const url = `${GATEWAY_BASE_URL}customer/v1/autologin/transactional-message`
  return axios.post(url, { email }, { withCredentials: true })
}

export async function sendCustomerCode (dni) {
  const url = `${GATEWAY_BASE_URL}customer/v1/send-customer-code`
  return axios.post(url, { dni })
}
